import { useState, useEffect, useReducer, useMemo } from 'react';
import { getCompanyInfo, getBranches } from './services/services';
import * as language from '../src/constants/languages'
import { router } from './config/router'
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import SpinnerLoader from './components/SpinnerLoader';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { RouterProvider } from 'react-router-dom';

function App() {

  return (
    <div >
      <div >
        <div className='routerContainer'>
          <RouterProvider router={router} />
        </div>
      </div>
    </div>
  );
}

export default App;
